import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Container } from './../../../base/Container'
import AppToaster from './../../../commonLib/AppToaster'
import { loadingMiniContext } from './../../../commonLib/lodingMiniContext'
import { Spinner } from './../../../commonLib/Spinner'
import * as bankCrud from './../../../_crud/cheque/bankCrud'
import { PagingEmpty } from './../../../commonLib/PagingEmpty'
import { MyAlert } from './../../../commonLib/MyAlert';
import { UserView } from './../../Global/Elements/UserView'
import { EmptyData } from './../../../commonLib/EmptyData'
import { GetEAccountTypeName } from '../../../enumCollections/EAccountType'

export function ManageBank() {
    const [isLoadingMini, setIsLoadingMini] = useContext(loadingMiniContext)
    const [bank, setBank] = useState([])

    useEffect(() => {
        getData()
    }, []);

    function getData() {
        setIsLoadingMini(true);
        bankCrud.GetAll()
            .then(res => {
                if (res.data.data) {
                    if (res.data.result.succeeded) {
                        let hdata = res.data.data
                        setBank(hdata);
                    }
                    else {
                        setBank([]);
                        AppToaster("Server Error /Invalid Try.", 'error')
                    }
                }
                else {
                    setBank([]);
                }
                setIsLoadingMini(false);
            })
            .catch(error => {
                setIsLoadingMini(false);
                AppToaster(error, 'error')
            })
    }

    function doRefresh(event) {
        getData()
        setTimeout(() => {
            event.detail.complete();
        }, 1000);
    }

    const DeleteItem = (id) => {
        setIsLoadingMini(true)
        bankCrud.Remove(id)
            .then(res => {
                if (res.data.succeeded) {
                    setIsLoadingMini(false)
                    AppToaster('Deleted successfully.', 'success')
                    getData()
                }
                else {
                    setIsLoadingMini(false)
                    AppToaster('Using by someone, could not delete.', 'error')
                }

            }).catch(error => {
                setIsLoadingMini(false)
                AppToaster('Network error', 'error')
            })
    }

    return (
        <>
            <Container title="Bank Accounts" doRefresh={doRefresh}>
                <Link to="/bank/add" class="btn btn-sm btn-success">
                    <i class="ace-icon glyphicon glyphicon-plus bigger-110"></i>
                    New
                </Link>
                <div class="hr dotted"></div>
                <PagingEmpty text={"Total " + bank.length + " items."}>
                    {isLoadingMini ?
                        <Spinner />
                        :
                        bank && bank.length > 0 ?
                            <div className="tables-scroll">
                                <table className="table table-hover table-bordered">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Bank Name</th>
                                            <th>Branch</th>
                                            <th>IFSC Code</th>
                                            <th>City</th>
                                            <th>State</th>
                                            <th>Address</th>
                                            <th>Account Holder Name</th>
                                            <th>Account No</th>
                                            <th>Account Type</th>
                                            <th style={{ width: "43px" }}>By</th>
                                            <th style={{ width: "72px" }}></th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {bank.map((item, index) =>
                                            <tr key={item.id}>

                                                <td>{index + 1}</td>
                                                <td>{item.bankName}</td>
                                                <td>{item.branch}</td>
                                                <td>{item.ifscCode}</td>
                                                <td>{item.city}</td>
                                                <td>{item.state}</td>
                                                <td>{item.address}</td>
                                                <td>{item.accountHolderName}</td>
                                                <td>{item.accountNo}</td>
                                                <td><span class={item.accountType == 1 ? "label label-sm label-success" : "label label-sm label-primary"}>{GetEAccountTypeName(item.accountType)}</span></td>
                                                <td>
                                                    <UserView item={item.createdByUser} uid={"D" + index} createdOn={item.createdOn} />
                                                </td>
                                                <td>
                                                    <div style={{ width: "73px" }}>
                                                        <div class="btn-group">
                                                            <Link to={"/bank/edit/" + item.id} class="btn btn-xs btn-success">
                                                                <i class="ace-icon fa fa-pencil bigger-120"></i>
                                                            </Link>
                                                            <MyAlert confirmBtnText="Yes, delete it!" title="Delete" onConfirm={DeleteItem} param={item.id}>
                                                                <i class="ace-icon fa fa-trash-o bigger-120"></i>
                                                            </MyAlert>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            :
                            <EmptyData>
                                No records found.
                                <br />
                                <br />
                            </EmptyData>
                    }
                </PagingEmpty>
            </Container >
        </>
    )
}
